"use client";

import Link from "next/link";
import { Heading } from "@/components/ui/typography";
import React from "react";

export default function SuccessSection({ heading = "Is Hong Kong offshore tax legal, and does it actually work?" }: { heading?: string } = {}) {
  return (
    <section className="w-full bg-black md:py-[60px] py-[30px] min-[1340px]:px-0 px-4">
      <div className="flex flex-col lg:flex-row gap-8 items-center max-w-[1200px] mx-auto">
        {/* LEFT HEADING */}
        <Heading as="h2" variant="section" className="flex-1">
          {heading}
        </Heading>

        {/* RIGHT CARD */}
        <div className="flex-1 flex flex-col gap-[50px]">
          <div className="bg-[#0f1218] border border-white/10 rounded-[12px] p-6 lg:p-12 flex flex-col gap-6 shadow-sm">
            <p className="text-left leading-tight">
              <span className="text-white/70 font-inter text-[16px] lg:text-[18px]">
                Short answer
                <br />
              </span>

              <span className="text-[#00a63e] font-cambo text-[48px] lg:text-[100px] leading-[100%] tracking-[-2px]">
                Yes
              </span>

              <span className="text-[#00a63e] font-combo text-[48px] lg:text-[100px] leading-[100%]">
                .
                <br />
              </span>

              <span className="text-white font-bebas text-[20px] lg:text-[28px] leading-[100%]">
                <br />
              </span>

              <span className="text-white/70 font-inter text-[14px] leading-[160%] font-medium">
                Hong Kong operates under a territorial tax principle. If your
                company earns profits from customers outside Hong Kong, those
                profits may qualify for 0% taxation under Inland Revenue
                Department rules. MuteTaxes structures your company correctly
                from day one and applies for your{" "}
                <Link href="/tax-optimization" className="hover:underline">
                  IRD offshore profits exemption
                </Link>{" "}
                so your tax position is documented and defensible.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
